import { ReactComponent as IconCalendar } from 'assets/images/svg/calendar.svg';
import React, { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePicker.scss';

interface DatePickerProps {
  className?: string;
  startDate?: Date;
  endDate?: Date;
  onChange: (dates: { startDate: Date | null; endDate: Date | null }) => void;
}

const DatePicker = ({ className = '', startDate, endDate, onChange }: DatePickerProps) => {
  const [start, setStartDate] = useState<Date | null>(startDate || null);
  const [end, setEndDate] = useState<Date | null>(endDate || null);

  const handleStartDateChange = (date: Date | null) => {
    setStartDate(date);
    onChange({ startDate: date, endDate: end });
  };

  const handleEndDateChange = (date: Date | null) => {
    setEndDate(date);
    onChange({ startDate: start, endDate: date });
  };

  return (
    <div className={`date-picker ${className}`}>
      <div className='date-picker__button start'>
        <ReactDatePicker
          selected={start}
          onChange={handleStartDateChange}
          selectsStart
          startDate={start as Date}
          endDate={end as Date}
          dateFormat={'MMM d, yyyy'}
          customInput={
            <button className={'date-picker__value'}>
              <IconCalendar />
              {start
                ? start.toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                  })
                : 'Select Start Date'}
            </button>
          }
        />
      </div>
      <div className='date-picker__button end'>
        <ReactDatePicker
          selected={end}
          onChange={handleEndDateChange}
          selectsEnd
          startDate={start as Date}
          endDate={end as Date}
          minDate={start as Date} // Prevent end date from being earlier than start date
          dateFormat={'MMM d, yyyy'}
          customInput={
            <button className={'date-picker__value'}>
              <IconCalendar />
              {end
                ? end.toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                  })
                : 'Select End Date'}
            </button>
          }
        />
      </div>
    </div>
  );
};

export default DatePicker;
